import axios, { AxiosInstance } from 'axios';
import { apiConfig } from '@/config/apiConfig';
import { getVoiceFallbackClient } from './_shared';

// ── Seasonal Trigger Rules (/api/seasonal-triggers) — auto-segmentation (BOOSTT-3171) ─

export type SeasonalTriggerAnchorField = 'last_service_date' | 'last_contact_date';

export type SeasonalTriggerRule = {
  id: string;
  campaign_id: string;
  name: string;
  anchor_field: SeasonalTriggerAnchorField;
  interval_months: number;
  service_type?: string | null;
  is_active: boolean;
  last_run_at?: string | null;
  created_at: string;
  updated_at: string;
};

export type CreateSeasonalTriggerRuleInput = {
  campaign_id: string;
  name: string;
  anchor_field: SeasonalTriggerAnchorField;
  interval_months: number;
  service_type?: string;
};

export type UpdateSeasonalTriggerRuleInput = {
  name?: string;
  anchor_field?: SeasonalTriggerAnchorField;
  interval_months?: number;
  service_type?: string;
  is_active?: boolean;
};

export async function fetchSeasonalTriggerRules(campaignId: string, axiosInstance?: AxiosInstance): Promise<SeasonalTriggerRule[]> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.get<SeasonalTriggerRule[]>(apiConfig.voiceEndpoints.seasonalTriggers, { params: { campaign_id: campaignId } });
  return response.data;
}

export async function createSeasonalTriggerRule(input: CreateSeasonalTriggerRuleInput, axiosInstance?: AxiosInstance): Promise<SeasonalTriggerRule> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.post<SeasonalTriggerRule>(apiConfig.voiceEndpoints.seasonalTriggers, input);
  return response.data;
}

export async function updateSeasonalTriggerRule(id: string, input: UpdateSeasonalTriggerRuleInput, axiosInstance?: AxiosInstance): Promise<SeasonalTriggerRule> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.patch<SeasonalTriggerRule>(`${apiConfig.voiceEndpoints.seasonalTriggers}/${id}`, input);
  return response.data;
}

export async function deleteSeasonalTriggerRule(id: string, axiosInstance?: AxiosInstance): Promise<void> {
  const client = axiosInstance || getVoiceFallbackClient();
  await client.delete(`${apiConfig.voiceEndpoints.seasonalTriggers}/${id}`);
}
